"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFairs = void 0;
const wm_portal_lib_api_core_1 = require("@webmotors/wm-portal-lib-api-core");
const ajax_1 = require("../../ajax");
const parser_1 = require("./parser");
const fairsEndpoint = 'carfair';
const getFairs = ({ type }) => {
    return wm_portal_lib_api_core_1.api
        .get({
        url: fairsEndpoint,
        httpInstance: (0, ajax_1.ajax)(),
        queryParams: {
            type,
        },
    })
        .then((response) => response.data)
        .then(parser_1.parseFairs);
};
exports.getFairs = getFairs;
//# sourceMappingURL=index.js.map